import { ReactNode } from 'react';
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';

interface GoogleAnalyticsProviderProps {
  children: ReactNode;
}

function GoogleAnalyticsInitializer() {
  // This hook handles all GA initialization and tracking
  useGoogleAnalytics();
  return null;
}

export function GoogleAnalyticsProvider({ children }: GoogleAnalyticsProviderProps) {
  return (
    <>
      <GoogleAnalyticsInitializer />
      {children}
    </>
  );
}
